import { router } from "@inertiajs/react";
import { useEffect, useState } from "react";
import type { TaskData } from "@/components/TaskRow";

// A full Inertia reload leaves the optional set out; what was loaded once stays shown.
export function useLoadedCompleted(completedTasks: TaskData[] | null | undefined): TaskData[] | null {
  const [loaded, setLoaded] = useState<TaskData[] | null>(completedTasks ?? null);
  useEffect(() => {
    if (completedTasks !== undefined && completedTasks !== null) setLoaded(completedTasks);
  }, [completedTasks]);
  return completedTasks ?? loaded;
}

// `local` is the Completed block already held on the device; the server's full set is then
// fetched only on request, for what the device does not hold.
export function useCompletedSection(completedTasks: TaskData[] | null | undefined, local: TaskData[] | null = null) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingOlder, setLoadingOlder] = useState(false);
  const cached = useLoadedCompleted(completedTasks);

  function loadFromServer(onFinish: () => void) {
    router.reload({ only: ["completedTasks"], onFinish });
  }

  function toggle() {
    if (loading) return;
    if (open) {
      setOpen(false);
      return;
    }
    const nothingToShow = local === null ? cached === null : local.length === 0 && cached === null;
    if (nothingToShow) {
      setLoading(true);
      loadFromServer(() => {
        setLoading(false);
        setOpen(true);
      });
      return;
    }
    setOpen(true);
  }

  function loadOlder() {
    if (loadingOlder) return;
    setLoadingOlder(true);
    loadFromServer(() => setLoadingOlder(false));
  }

  return {
    open,
    loading,
    cached: local ?? cached,
    toggle,
    canLoadOlder: local !== null && cached === null,
    loadingOlder,
    loadOlder,
  };
}
